import { useState, useRef, useEffect } from "react"
import { SmilePlus } from "lucide-react"

import { getFeathersClient } from "./feathers-client"
import { EmojiPicker } from "@/components/emoji-picker"
import { ColorSet } from "@/theme/color"
import { User } from "../../../../shared-src/user"

export function AddReactionButton(props: {
	messageUlid: string
	channelId: string
	selfUser: User | null
	selfUserColorSet: ColorSet
}) {
	const [showEmojiPicker, setShowEmojiPicker] = useState(false)
	const emojiPickerRef = useRef<HTMLDivElement>(null)
	const buttonRef = useRef<HTMLButtonElement>(null)
	const messagesService = getFeathersClient().service('messages')
	const [positionAbove, setPositionAbove] = useState(false)
	const [positionRight, setPositionRight] = useState(false)

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target as Node))
				setShowEmojiPicker(false)
		}

		if (showEmojiPicker)
			document.addEventListener('mousedown', handleClickOutside)

		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [showEmojiPicker])

	const handleButtonClick = () => {
		if (!showEmojiPicker && buttonRef.current) {
			const rect = buttonRef.current.getBoundingClientRect()
			const spaceBelow = window.innerHeight - rect.bottom
			const spaceLeft = rect.left
			const pickerHeight = 320
			const pickerWidth = 260
			setPositionAbove(spaceBelow < pickerHeight)
			setPositionRight(spaceLeft < pickerWidth)
		}
		setShowEmojiPicker(!showEmojiPicker)
	}

	const handleAddReaction = async (emojiChar: string) => {
		if (!props.selfUser?.userId || !props.channelId)
			return

		setShowEmojiPicker(false)

		try {
			await messagesService.patch(props.messageUlid, {
				action: 'add-reaction',
				emoji: emojiChar,
				channelId: props.channelId
			})
		} catch (error) {
			console.error('Error adding reaction:', error)
		}
	}

	return (
		<div className="relative opacity-100 bg-white rounded-full h-6 flex items-center justify-center" ref={emojiPickerRef}>
			<button
				ref={buttonRef}
				type="button"
				className="hover:bg-gray-100 rounded-full p-1"
				onClick={handleButtonClick}
				title="Add reaction"
				style={{ color: props.selfUserColorSet.border }}
			>
				<SmilePlus className="h-4 w-4" />
			</button>

			{showEmojiPicker && (
				<div className={`fixed z-50 ${positionAbove ? 'bottom-full mb-1' : 'top-full mt-1'} ${positionRight ? 'left-0' : 'right-0'}`}
					style={{
						top: positionAbove ? undefined : (buttonRef.current?.getBoundingClientRect().bottom ?? 0) + 4,
						bottom: positionAbove ? window.innerHeight - (buttonRef.current?.getBoundingClientRect().top ?? 0) + 4 : undefined,
						left: positionRight ? (buttonRef.current?.getBoundingClientRect().left ?? 0) : undefined,
						right: positionRight ? undefined : window.innerWidth - (buttonRef.current?.getBoundingClientRect().right ?? 0)
					}}
				>
					<EmojiPicker
						onPick={(shortcode, emojiChar) => handleAddReaction(emojiChar)}
					/>
				</div>
			)}
		</div>
	)
}